module.exports = __webpack_public_path__ + "images/file_icons_v2/swift-8410d303c442618400661910d4ad0a80.svg";